/**
 * Profile-update statuses shared by the sidebar tabs and their fixed filter values.
 *
 * The Receipt table renders two models under the same columns. The API's explicit `source`
 * discriminator decides which model a row represents and therefore which modal the eye opens:
 *   - дескрипторний рядок → `Profile details` (одна колонка VALUE);
 *   - profile-update рядок → `Requested profile update` (CURRENT / PROPOSED).
 *
 * Значення збігаються з `ReceiptProfileUpdateStatus` на бекенді і з id сайд-табів
 * у `RequestsPage/index.js` — міняти лише разом з ними.
 */
export const PROFILE_UPDATE_STATUSES = Object.freeze([
  "pending_update",
  "update_in_progress",
  "updated",
  "updated_failed"
])

export const isProfileUpdateRow = (row) => row?.source === "profile_update"
